var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchIcn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "17px",
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mobile---quote-start-[v2]",
    transform: "translate(-256.000000, -1152.000000)",
    fill: "#0B7BFB"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(16.000000, 1082.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2733\\uFE0F-molecules/text-input/special/car-reg/desktop/empty",
    transform: "translate(0.000000, 46.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component/Special/Car-Reg-Long"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a-symbol-button",
    transform: "translate(224.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Button/Pill/Grey"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u269B-atoms/icons/16/search/blue",
    transform: "translate(16.000000, 7.000033)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7812124,14.334396 C16.0718306,14.628127 16.0718306,15.103132 15.7780996,15.3968935 L14.8937023,16.2812603 C14.6030841,16.5750218 14.1280791,16.5750218 13.8343481,16.2812603 L10.7187244,13.1656366 C10.5780998,13.025012 10.499975,12.8343996 10.499975,12.6343879 L10.499975,12.1250202 C9.3968587,12.9875059 8.0093498,13.5000169 6.4999845,13.5000169 C2.90935586,13.5000169 2.22932783e-13,10.5906611 2.22932783e-13,7.00003242 C2.22932783e-13,3.40940378 2.90935586,0.500047922 6.4999845,0.500047922 C10.0906131,0.500047922 12.999969,3.40940378 12.999969,7.00003242 C12.999969,8.50939772 12.487458,9.89690662 11.6249723,11.0000229 L12.13434,11.0000229 C12.3343517,11.0000229 12.524964,11.0781477 12.6655887,11.2187724 L15.7812124,14.334396 Z M6.49999404,11.0000229 C8.71247312,11.0000229 10.499975,9.20940826 10.499975,7.00004196 C10.499975,4.7875438 8.70936034,3.00004196 6.49999404,3.00004196 C4.28749588,3.00004196 2.49999404,4.79065659 2.49999404,7.00004196 C2.49999404,9.21252105 4.29060867,11.0000229 6.49999404,11.0000229 Z",
    id: "search-icn-blue"
  })))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcn);
export default __webpack_public_path__ + "static/media/search-icn.f87cdb2a4128c9b5083ca7ce4884d7bc.svg";
export { ForwardRef as ReactComponent };